import { apiGet, apiPut, apiPost } from './client';
import { User, ApiResponse } from '@tinyrewards/shared';

export function getMyProfile(): Promise<ApiResponse<User>> {
    return apiGet<User>('/api/users/me');
}

export function updateMyProfile(data: { firstName: string; lastName: string; organizationName?: string; bio?: string; publicPageShare?: boolean }): Promise<ApiResponse<User>> {
    return apiPut<User>('/api/users/me', data);
}

export function markProfileComplete(): Promise<ApiResponse<User>> {
    return apiPut<User>('/api/users/me/profile-complete', {});
}

export function changePassword(currentPassword: string, newPassword: string): Promise<ApiResponse<void>> {
    return apiPost<void>('/api/users/change-password', { currentPassword, newPassword });
}

export function uploadAvatar(file: File): Promise<ApiResponse<{ imageUrl: string }>> {
    const formData = new FormData();
    formData.append('avatar', file);
    return fetch('/api/users/avatar', {
        method: 'POST',
        credentials: 'include',
        body: formData,
    }).then(r => r.json()) as Promise<ApiResponse<{ imageUrl: string }>>;
}
